var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActionResolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.216 12.839L10.63 11.425L12.044 10.011L13.459 11.425L14.337 12.304L18.216 8.425L19.5 7.141V5.5H13.9L13.5 3.5H4.5V20.5H6.5V13.5H8.555L9.216 12.839Z",
    fill: "#F63B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 9.83899L21.044 11.253L14.337 17.96L10.63 14.253L12.044 12.839L14.337 15.132L19.63 9.83899Z",
    fill: "#18CE99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionResolved);
export default __webpack_public_path__ + "static/media/icon-action-resolved.a4dd8b1ecdbb5bd80377a1b20d0b6a6e.svg";
export { ForwardRef as ReactComponent };